import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M2.5 10.417h19M8.027 2v3.402M15.983 2v3.402M18.86 22H5.139c-.7 0-1.371-.287-1.866-.798a2.77 2.77 0 0 1-.773-1.926V6.435c0-.723.278-1.416.773-1.926A2.6 2.6 0 0 1 5.14 3.71h13.722c.7 0 1.37.287 1.866.798.495.51.773 1.203.773 1.926v12.841c0 .723-.278 1.416-.773 1.926A2.6 2.6 0 0 1 18.86 22Z"
    />
  </svg>
);
export const CalendarIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
